import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useState,
} from "react";

interface Props {
  children: React.ReactNode;
}

export interface ApplicationLocation {
  path: Array<string>;
}

export interface ApplicationContextValue {
  state: ApplicationLocation;
  setState: Dispatch<SetStateAction<ApplicationLocation>>;
}

const initialState: ApplicationContextValue = {
  state: {
    path: [],
  },
  setState: (state) => {},
};

export const ApplicationLocationContext =
  createContext<ApplicationContextValue>(initialState);

export const ApplicationState: React.FC<Props> = ({ children }) => {
  // const [state, dispatch] = useReducer(applicationStateReducer, initialState);
  const [appState, setAppState] = useState(initialState.state);

  return (
    <ApplicationLocationContext.Provider
      value={{ state: appState, setState: setAppState }}
    >
      {children}
    </ApplicationLocationContext.Provider>
  );
};
